import * as React from "react";
import { ViewLarge, Viewport, ViewSmall } from "bernie-view";
import { inject } from "mobx-react";
import GalleryCarousel from "components/shared/Gallery/GalleryCarousel/GalleryCarousel";
import GalleryMosaic from "components/shared/Gallery/GalleryMosaic/GalleryMosaic";
import { getAttributionAltText } from "components/shared/AttributionText/AttributionText";
import { AspectRatioEnum } from "stores/thumbor/ThumborStore";
import { DestinationHeroGalleryProps } from "../typings";
import { Media } from "typings/microserviceModels/destination-hero-flex-module";
import { DestinationHeroHeading } from "components/flexComponents/DestinationHero/components/DestinationHeroHeading";
import { useLocalization } from "@shared-ui/localization-context";

export const DestinationHeroGallery = inject(
  "thumbor",
  "analytics"
)((props: DestinationHeroGalleryProps) => {
  const { flexComponent, context } = props;
  const { model } = flexComponent;
  const { content } = model;
  const { title, subTitle } = content;
  const isMobile = context && context.deviceInformation && context.deviceInformation.mobile;
  const imageGallery = () => {
    const { media } = content;
    if (!(media && media.length)) {
      return null;
    }

    const { formatText } = useLocalization();
    const { thumbor } = props;
    const [width, height] = isMobile ? [360, 224] : [1040, 580];
    const images = media.map((image: Media) => {
      const { mediaUrl, mediaUrlOriginal, mediaAlt, origin, source, author, authorUrl, license } = image;

      const thumborizedImageUrl = thumbor
        ? thumbor.safelyGenerateThumborizedImageUrl(
            mediaUrl,
            width,
            height,
            context,
            AspectRatioEnum.DEFAULT,
            isMobile,
            80
          )
        : mediaUrl;

      return {
        alt: getAttributionAltText(source, origin, title, mediaAlt, author, license, mediaUrlOriginal),
        src: thumborizedImageUrl,
        source,
        origin,
        caption: mediaAlt,
        thumbnailSrc: thumborizedImageUrl,
        attribUrl: mediaUrlOriginal,
        authorName: author,
        authorUrl,
        licenseSuite: license?.suite,
        licenseName: license?.name,
        licenseUrl: license?.url,
        originalMediaUrl: mediaUrl,
      };
    });

    return (
      <Viewport>
        <ViewSmall>
          <GalleryCarousel
            analyticsId="TG.LP"
            analyticsModule="Dest"
            analytics={props.analytics}
            title={formatText("destinationImageGallery.thumbnails.title", title)}
            images={images}
          />
        </ViewSmall>

        <ViewLarge>
          <GalleryMosaic
            analyticsId="TG.LP"
            analyticsModule="Dest"
            analytics={props.analytics}
            title={formatText("destinationImageGallery.title", title)}
            images={images}
          />
        </ViewLarge>
      </Viewport>
    );
  };

  return (
    <div
      id={flexComponent.id}
      data-fm={flexComponent.fmId}
      data-fm-title-id={flexComponent.fmTitleId}
      className="DestinationHeroDx uitk-cell all-cell-1-1"
    >
      <meta itemProp="name" content={subTitle ? `${title}, ${subTitle}` : title} />
      <meta itemProp="image" content={content.media[0].mediaUrl} />

      <DestinationHeroHeading flexComponent={flexComponent} context={context} analytics={props.analytics} />

      {imageGallery()}
    </div>
  );
});
